<template>
  <div class="rounded-xl border border-white/10 bg-bochas-bg/45 p-4 sm:p-5">
    <div class="mb-4 flex items-center justify-between gap-3">
      <div class="flex items-center gap-2">
        <IconFbochas name="trophy" :size="22" color="#d32929" />
        <h2 class="text-base font-semibold text-white">Logros</h2>
      </div>
      <button
        type="button"
        class="rounded-lg border border-bochas-rojo/30 bg-bochas-rojo/10 px-3 py-2 text-xs font-semibold text-red-200 transition-colors hover:bg-bochas-rojo/20"
        @click="addAchievement"
      >
        + Agregar logro
      </button>
    </div>

    <div class="space-y-3">
      <div
        v-for="(_, index) in modelValue"
        :key="index"
        class="flex items-center gap-2"
      >
        <span class="text-bochas-rojo">•</span>
        <input
          :value="modelValue[index]"
          type="text"
          class="min-w-0 flex-1 rounded-lg border border-gray-700 bg-bochas-bg px-4 py-3 text-white placeholder-gray-500 transition-colors focus:border-bochas-rojo focus:outline-none"
          :placeholder="`Logro ${index + 1}`"
          @input="updateAchievement(index, $event.target.value)"
        />
        <button
          type="button"
          class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-red-400/20 bg-red-500/10 text-red-300 transition-colors hover:bg-red-500/20"
          title="Eliminar logro"
          aria-label="Eliminar logro"
          @click="removeAchievement(index)"
        >
          <IconFbochas name="trash" :size="16" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import IconFbochas from "@/components/Icons/IconFbochas.vue";

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(["update:modelValue"]);

function addAchievement() {
  emit("update:modelValue", [...props.modelValue, ""]);
}

function updateAchievement(index, value) {
  const next = [...props.modelValue];
  next[index] = value;
  emit("update:modelValue", next);
}

function removeAchievement(index) {
  const next = props.modelValue.filter((_, itemIndex) => itemIndex !== index);
  emit("update:modelValue", next.length ? next : [""]);
}
</script>
